export default __webpack_public_path__ + "static/media/logo_slogan-white.921679f1.svg";